var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_942_667",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_942_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 29.1667C5.03158 29.1667 4.34519 28.8813 3.77449 28.3106C3.20283 27.739 2.91699 27.0521 2.91699 26.25V8.74999C2.91699 7.94791 3.20283 7.26152 3.77449 6.69083C4.34519 6.11916 5.03158 5.83333 5.83366 5.83333H13.1253V8.74999H5.83366V26.25H29.167V8.74999H21.8753V5.83333H29.167C29.9691 5.83333 30.6559 6.11916 31.2276 6.69083C31.7983 7.26152 32.0837 7.94791 32.0837 8.74999V26.25C32.0837 27.0521 31.7983 27.739 31.2276 28.3106C30.6559 28.8813 29.9691 29.1667 29.167 29.1667H5.83366ZM17.5003 22.4583L10.2087 15.1667L12.2503 13.125L16.042 16.9167V5.83333H18.9587V16.9167L22.7503 13.125L24.792 15.1667L17.5003 22.4583Z",
    fill: "#1C1B1F",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportSvg);
export default __webpack_public_path__ + "static/media/exportSvg.ac1f1850a51aeb7be68fee123ca786ef.svg";
export { ForwardRef as ReactComponent };